import { zodQueryBoolean } from "../../../utils/query";
import { z } from "zod";
export const DTOStorybookEntryOrigin = z.object({
    id: z.string(),
    type: z.enum(["story", "docs"]),
    name: z.string(),
    title: z.string(),
});
export const DTOStorybookEntry = z.object({
    id: z.string(),
    storyId: z.string(),
    designSystemId: z.string(),
    sourceId: z.string(),
    aliases: z.array(z.string()).optional(),
    url: z.string(),
    isDeleted: z.boolean().optional(),
    origin: DTOStorybookEntryOrigin,
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const DTOStorybookEntryReplaceAction = z.object({
    newStoryId: z.string(),
});
export const DTOStorybookEntryQuery = z.object({
    /**
     * Unique ID across versions (non-persistent ID)
     */
    brandId: z.string().optional(),
    excludeDocs: zodQueryBoolean(),
});
export const DTOStorybookEntryListResponse = z.object({
    entries: z.array(DTOStorybookEntry),
});
export const DTOStorybookEntryResponse = z.object({ entry: DTOStorybookEntry });
